import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
//import circleOfInfluence_instruction_main from './images/circleOfInfluence_instruction_main.png'
//import CircleOfInfluenceConcern from './images/CircleOfInfluenceConcern.png'
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import SpeakerNotesIcon from '@material-ui/icons/SpeakerNotes';

import styles from './../../../../Styles';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import ViewListIcon from '@material-ui/icons/ViewList';
import journey_sl_init from './../images/journey_sl_init.png';
import journey_sl_active from './../images/journey_sl_active.png';
import journey_sl_results from './../images/journey_sl_results.png';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const INITIAL_STATE = {
    open: false,
    legendOpen: false
};

class HostInstructions extends Component {

    constructor(props) {
        super(props);
        // session.active_game.results
        this.state = {
          ...INITIAL_STATE,
        };
    }

    handleClickOpen = () => {
        this.setState({
            ...this.state,
            open: true
        });
    };
    
    handleClose = () => {
        this.setState({
            ...this.state,
            open: false
        });
    };

    handleLegendClickOpen = () => {
        this.setState({
            ...this.state,
            legendOpen: true
        });
    };
    
    handleLegendClose = () => {
        this.setState({
            ...this.state,
            legendOpen: false
        });
    };

    render() {
        const {
        //game_id, game_title, session, profile, auth, group_state, game_state,
        classes,
        } = this.props;

        return (
        <div>
            <Typography variant='h5' className={classes.greyText}>
                Host Tools
            </Typography>
            <div className={classes.spacingTop}>
                { /* <img src={CircleOfInfluenceConcern} alt='Circle of Influence' className={classes.smallImageSize} /> */ }
                <div><Button 
                        variant="contained"
                        color="primary"
                        startIcon={<SpeakerNotesIcon />}
                        onClick={this.handleClickOpen}
                        >
                    Leader Notes
                    </Button>
                    <div className={classes.spacingTop}>
                        <Button 
                            variant="contained"
                            color="primary"
                            startIcon={<ViewListIcon />}
                            onClick={this.handleLegendClickOpen}
                            >
                        State Legend
                        </Button>
                    </div>
                </div>
            </div>
            <Dialog open={this.state.open} onClose={this.handleClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        Leader Notes
                        </Typography>                    
                </Toolbar>
                </AppBar>
          
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                   
                    <div className={classes.bodyText}>
                            
                            <div className={classes.boldedText}>Greatest Challenges</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Plus/Delta - Program so far/Leadership Road</li>
                                <li className={classes.properListItem}>Plus - what has worked well for you</li>
                                <li className={classes.properListItem}>Delta is the Greek word/symbol for change - what would you want to change?</li>

            
                            </ul>
                            <br/>
                            <div className={classes.boldedText}>Consider</div>
                            <ul className={classes.properList}>
                                <li className={classes.properListItem}>Roadmaps; Scenic Route; Manager Support; GlobalOD; recording videos; worksheets with Roadmaps; information covered.</li>
                                <li className={classes.properListItem}>Create a flip chart and we will then move around to your charts to hear your feedback.</li>
                            </ul>
                            

                           
                        </div>                          
                    </Grid>
                </Grid>
                
                                
            </Dialog>
            <Dialog  open={this.state.legendOpen} onClose={this.handleLegendClose} TransitionComponent={Transition}>
                <AppBar position="static">
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={this.handleLegendClose} aria-label="close">
                    <CloseIcon />
                    </IconButton>
                        <Typography variant="h6" className={classes.boldedText}>
                        State Legend
                        </Typography>                    
                </Toolbar>
                </AppBar>
                <Grid container spacing={2} className={classes.dialogueGrid}>
                    <Grid item xs={12}  className={classes.spacingTop}>
                    <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Init</Typography>
                        <div>
                            <img src={journey_sl_init}  className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Active</Typography>
                        <div>
                            <img src={journey_sl_active}  className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        <Typography variant="body1" className={`${classes.boldedText} ${classes.spacingTop}`}>Results</Typography>
                        <div>
                            <img src={journey_sl_results}  className={`${classes.imageSize} ${classes.borderImage}`}/>
                        </div>
                        
                        
                    </Grid>
                </Grid>
                
                                
            </Dialog>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
  //console.log('this is my state', state);
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(connect(mapStateToProps, mapDispatchToProps), withStyles(styles))(HostInstructions);
